import { mapState } from 'pinia';
import stores from 'store/modules';
import sEmitter from 'storage-emitter';
import { v4 as uuidv4 } from 'uuid';
import { Howl } from 'howler';

let Howler = null;
let canPlayUnread = true;

export default {
    data: () => ({
        soundTabs: {
            id: uuidv4(),
            current: null,
        },
        tabIndicator: {
            interval: null,
            title: document.title,
        },
        targetInbox: null,
    }),

    computed: {
        ...mapState(stores.Inboxes, ['inbox', 'inboxes']),
        ...mapState(stores.User, ['user', 'isAway']),
        ...mapState(stores.Unread, ['unreadCount']),
    },

    methods: {
        echoMessagePopper(e) {
            // TODO: SWR-14336: Will be uncommit and updated with SWR-14336
            // this.$store.dispatch('setLogItem', {
            //     logLevel: 'info',
            //     message: 'EventMessagePopper',
            //     details: {
            //         inboxId: e.inbox_id,
            //         userId: e.user_id,
            //     },
            // });

            if (!document.hasFocus()) {
                setTimeout(() => {
                    this.triggerTabIndicator(e);
                }, 2000);
            }

            this.playUnreadPop(e);
        },

        initSoundTabs() {
            // When a tab closes, if the new [0] index is this tab, it gets
            // to take over sound playing privileges.
            sEmitter.on('window.closed', (tabIds) => {
                if (tabIds[0] === this.soundTabs.id) {
                    this.soundTabs.current = true;
                }
            });

            // First, load the IDs from storage. If there are none, set this tab
            // to the current and store it's ID. If there are IDs, append this ID
            // to the array and move on.
            let tabIds = JSON.parse(localStorage.getItem('soundTabIds'));
            if (Array.isArray(tabIds) && tabIds.length) {
                tabIds.push(this.soundTabs.id);
            } else {
                tabIds = [this.soundTabs.id];
                this.soundTabs.current = true;
            }

            // Store the new tabIds in storage for access on newly opened tabs.
            localStorage.setItem('soundTabIds', JSON.stringify(tabIds));

            // Before we close the tab, we need to see if we're the last tab
            // open. If we are, remove the localStorage cache. If we are not,
            // tell other tabs we closed up shop.
            window.onbeforeunload = () => {
                let tabIds = JSON.parse(window.localStorage.getItem('soundTabIds'));

                if (!tabIds) {
                    return;
                }

                if (tabIds.length === 1) {
                    window.localStorage.removeItem('soundTabIds');
                } else {
                    tabIds = tabIds.filter((id) => id !== this.soundTabs.id);
                    window.localStorage.setItem('soundTabIds', JSON.stringify(tabIds));

                    sEmitter.emit('window.closed', tabIds);
                }
            };
        },

        initTabIndicator() {
            window.addEventListener('focus', () => {
                if (this.tabIndicator.interval) {
                    clearInterval(this.tabIndicator.interval);
                    document.title = this.tabIndicator.title;
                }
            });
        },

        triggerTabIndicator(e) {
            const newTitle = `(${this.unreadCount}) ${e.contact || 'Somebody'} says...`;

            if (this.tabIndicator.interval) {
                clearInterval(this.tabIndicator.interval);
            }

            document.title = newTitle;

            this.tabIndicator.interval = setInterval(() => {
                if (document.title !== this.tabIndicator.title) {
                    document.title = this.tabIndicator.title;
                } else {
                    document.title = newTitle;
                }
            }, 2000);
        },

        playUnreadPop(e) {
            this.targetInbox = this.inboxes[e.inbox_id];

            if (this.targetInbox && this.targetInbox.isMuted) return;

            if (
                !Howler ||
                this.inbox.id !== e.inbox_id ||
                (this.user.id !== e.user_id && e.user_id !== 0) ||
                this.isAway
            ) {
                return;
            }

            canPlayUnread = false;

            Howler.load();
            Howler.play();
        },

        initHowler() {
            Howler = new Howl({
                volume: 0.4,
                src: ['/sounds/notification.mp3'],
                preload: false,
                autoplay: false,
                howl: null,
                onend: () => {
                    canPlayUnread = true;
                },
                onplayerror: () => {
                    if (this.targetInbox && this.targetInbox.isMuted) return;
                    Howler.play();
                },
            }).load();
        },

        handleDocumentClick() {
            document.removeEventListener('click', this.handleDocumentClick);
            this.initHowler();
        },
    },

    mounted() {
        this.initHowler();
        this.initSoundTabs();
        this.initTabIndicator();

        document.addEventListener('click', this.handleDocumentClick);
    },
};
